import React from 'react';

import './Inputs.scss';

export default class PhoneNumInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            suffixInput: null,
            prefixData: '',
            suffixData: ''
        }

        this.saveInput = this.saveInput.bind(this);
    }

    render() {
        let invalidClass = this.props.isInvalid ? 'invalid' : '';

        return (
            <div className={`phone-input a-input ${invalidClass} ${this.props.styleClass}`}>
                <input
                    className="prefix"
                    type="text"
                    maxLength="3"
                    name="prefix"
                    onChange={(e)=>this.changeData(e)}
                />
                <input
                    ref={this.saveInput}
                    type="text"
                    name={`suffix-${this.props.name}`}
                    onChange={(e) => this.changeData(e)}
                    maxLength="7"
                />
            </div>
        );
    }

    saveInput(domEl) {
        this.setState({
            suffixInput: domEl
        });
    }

    changeData(e) {
        let el = e.target;
        let field = el.name === "prefix" ? "prefixData" : "suffixData";

        this.state[field] = el.value;

        if (this.state.prefixData.length === 3) {
            if (this.state.suffixInput !== document.activeElement) this.state.suffixInput.focus();
        }

        let tempData = {
            target: {
                name: this.props.name,
                value: this.state.prefixData.length === 3 ? this.state.prefixData + this.state.suffixData : ""
            }
        };

        this.props.onChange(tempData);
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Form/Inputs/PhoneNumInput.jsx